import { createRoute, redirect } from '@tanstack/react-router'

import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { Watch } from 'domains/Workspaces/Video/Objects/Object/Blobs/Blob'
import { JSON } from 'domains/Workspaces/Video/Objects/Object/Blobs/Blob/JSON'
import { Structure } from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object/Blobs/Blob'
import { videoObjectBlobsRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object/Blobs/Routing'

export const videoObjectBlobRoute = createRoute({
  getParentRoute: () => videoObjectBlobsRoute,
  path: DynamicRouteParameterWPrefix.BLOB_ID,
  beforeLoad: ({ location, params: { blobId } }) => {
    const encodedParam = encodeURIComponent(blobId)
    if (location.pathname.endsWith(encodedParam) || location.pathname.endsWith(`${encodedParam}/`)) {
      throw redirect({ replace: true, from: videoObjectBlobRoute.fullPath, to: videoObjectBlobConfigRoute.to })
    }
  },
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const videoObjectBlobLayoutRoute = createRoute({
  getParentRoute: () => videoObjectBlobRoute,
  id: 'videoObjectBlobLayout',
  component: () => <Structure />,
})

export const videoObjectBlobConfigRoute = createRoute({
  getParentRoute: () => videoObjectBlobLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: JSON,
})

export const videoObjectBlobWatchRoute = createRoute({
  getParentRoute: () => videoObjectBlobLayoutRoute,
  path: StaticRouteParameter.WATCH,
  component: Watch,
})
